module.exports= {
    "postbox-text": "Tutaj wpisz komentarz (co najmniej 3 znaki)",
    "postbox-author": "Imię/nick (opcjonalnie)",
    "postbox-email": "E-mail (opcjonalnie)",
    "postbox-website": "Strona (opcjonalnie)",
    "postbox-preview": "Podgląd",
    "postbox-edit": "Edytuj",
    "postbox-submit": "Wyślij",
    "postbox-notification": "Otrzymuj powiadomienia o odpowiedziach na e-mail",

    "num-comments": "Jeden komentarz\n{{ n }} komentarze\n{{ n }} komentarzy",
    "no-comments": "Nie ma jeszcze komentarzy",
    "atom-feed": "Kanał Atom",

    "comment-reply": "Odpowiedz",
    "comment-edit": "Edytuj",
    "comment-save": "Zapisz",
    "comment-delete": "Usuń",
    "comment-confirm": "Potwierdź",
    "comment-close": "Zamknij",
    "comment-cancel": "Anuluj",
    "comment-deleted": "Komentarz usunięty.",
    "comment-queued": "Komentarz w kolejce do moderacji.",
    "comment-anonymous": "Anonim",
    "comment-hidden": "{{ n }} ukryty\n{{ n }} ukryte\n{{ n }} ukrytych",

    "date-now": "teraz",
    "date-minute": "minutę temu\n{{ n }} minuty temu\n{{ n }} minut temu",
    "date-hour": "godzinę temu\n{{ n }} godziny temu\n{{ n }} godzin temu",
    "date-day": "wczoraj\n{{ n }} dni temu",
    "date-week": "w ubiegłym tygodniu\n{{ n }} tygodnie temu\n{{ n }} tygodni temu",
    "date-month": "w ubiegłym miesiącu\n{{ n }} miesiące temu\n{{ n }} miesięcy temu",
    "date-year": "w ubiegłym roku\n{{ n }} lata temu\n{{ n }} lat temu"
};
